import { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchSubscribers } from "../util/fetchUserUtil";

export const AllUsersTable = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchSubscribers(postData, "users");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [];

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"all_users"}
        tableType={"all_users"}
        tableName={"All Users"}
        needGlobalFilter={true}
        needColumnFilter={true}
        needPagination={true}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={false}
      />
    </div>
  );
};

export default AllUsersTable;
